<template>
<div class="unitInformation">
  <div class="mainContent" :style="styleObject">
    <el-drawer :title="drawerTitle" size="1050px" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
      <unit-drawer v-if="drawerShow" :loading.sync="loading" @confirm="handleConfirm" @cancel="handleCancel" :editData="editData" :detailData="detailData" :selectAddr="selectAddress" @getPosition="mapVisible"></unit-drawer>
    </el-drawer>
    <div class="contentTable">
      <div class="query">
        <button class="primaryBtn" @click="addClick()" v-if="isPermit('org:add')">新增</button>
      </div>
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleCurrentChange" @sizeChange="handleSizeChange">
        <el-table-column type="selection" width="50" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="单位名称" width="180" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="industryStr" label="所属行业" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fireLevelStr" label="消防级别" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fireSafetyPersonLiable" label="消防安全责任人" width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fullTimeFireFightersCount" label="专职消防人" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="floorage" label="建筑面积" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firePassagesCount" label="消防车道数" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fireLiftCount" label="消防电梯数" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="refugeFloorAddress" label="避难层位置" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="image" label="公司图片" :show-overflow-tooltip="true">
          <template slot-scope="scope" v-if="scope.row.image">
            <img :src="scope.row.image" style="cursor:pointer" width="25" height="25" @click="imgMask(scope.row.image)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row)" v-if="scope.row.level<2&&isPermit('org:edit')" size="small" class="edit">编辑</el-button>
            <el-button @click="delClick(scope.row)" size="small" v-if="scope.row.level<2&&isPermit('org:del')" class="del">删除</el-button>
            <el-button @click="detail(scope.row)" size="small" v-if="scope.row.level>1" class="del">查看</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>
  <div class="imgMasking" v-if="showImg">
    <div class="closeBtn" @click="showImg = false"><i class="el-icon-circle-close" /></div>
    <div class="imgMask">
      <img :src="imgUrl" alt="">
    </div>
  </div>
  <div class="unitMap" :style="{left : mapShow ? '0' : '100%'}">
    <div class="closeBtn" @click="mapShow = false"><i class="el-icon-circle-close" /></div>
    <div class="mapBox" v-loading="mapLoading">
      <div class="mapSearch">
        <el-input ref="searchInput" v-model="mapSearch" placeholder="搜索地址"></el-input>
        <!-- <el-button type="primary" @click="searchMap">搜索</el-button> -->
      </div>
      <!-- <baidu-map class="map" :center="center" :zoom="zoom" @ready="mapReady" @click="mapClick" :scroll-wheel-zoom="true"> -->
      <baidu-map class="map" :center="center" :zoom="zoom" @ready="mapReady" @click="mapClick">
        <!-- 地图容器 -->
        <bm-view :style="{width:'100%',height: '100%'}"></bm-view>
        <bm-local-search :keyword="mapSearch" :auto-viewport="true" style="display:none;"></bm-local-search>
      </baidu-map>
      <div class="mapConfirm" v-if="locationSelected">
        <span>{{selectLocation.address}}</span><i @click.stop="saveLocation">保存位置</i>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/TreeTable";
import UnitDrawer from "@/components/unitInformation/UnitDrawer";
import {
  endianness
} from 'os';
export default {
  components: {
    BorderTable,
    UnitDrawer
  },
  data() {
    return {
      mapShow:false,
      mapSearch: '',
      center: {
        lng: '116.404',
        lat: '39.915'
      },
      location:{
        lng: '116.404',
        lat: '39.915'
      },
      keyword: '',
      zoom: 14,
      baiduMap: null,
      map: null,
      geocoder: null,
      mapLoading:false,
      locationSelected:false,
      selectLocation:{},
      selectAddress:{},
      drawerTitle:'',
      showImg: false,
      detailData:{},
      imgUrl: '',
      creatTime: "",
      selectedName: "",
      radio: "1",
      names: "",
      styleObject: {
        height: ""
      },
      tableLoading: false,
      editData: {},
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      drawerShow: false,
      loading: false,
      mapWidth:0,
      mapHeight:0,
      flag:false
    };
  },
  created() {
    this.mapWidth = document.body.clientWidth*0.8
    this.mapHeight = document.body.clientHeight*0.8
    this.makeheight();
    this.showList();
  },
  methods: {
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    showList() {
      this.tableLoading = true
      this.request.get("/organization/findTreeTalbe").then(data => {
         console.log(data);
         
        this.tableLoading = false
        if (data.code == 200) {
          this.dataList = data.data;
        } else {
          this.dataList = []
        }
      })
    },
    addClick() {
      this.drawerShow = true
      this.editData = {},
      this.detailData = {}
      this.drawerTitle = "新增单位信息";
      //定位到当前位置
      let map = this.map
      let BMap = this.baiduMap
      map.clearOverlays()
      this.center.lng = this.location.lng
      this.center.lat = this.location.lat
      let point = new BMap.Point(this.center.lng, this.center.lat);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.panTo(point)
      let gc = new BMap.Geocoder();
      gc.getLocation(point, res => {
        console.log(res);
        this.selectLocation = res
      })
    },
    //表格当前页变化时
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    //表格展示条数变化时
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    detail(row) {
      this.editData = {}
      this.request.get('/organization/query/' + row.id).then(data => {
        if (data.code == 200) {
          this.detailData = data.data;
          this.drawerShow = true;
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    editClick(row) { //编辑
      this.drawerTitle = "编辑单位信息";
      this.detailData = {}
      this.flag = true
      this.request.get('/organization/query/' + row.id).then(data => {
        if (data.code == 200) {
          this.editData = data.data;
          console.log(data.data);
          this.drawerShow = true;
          //地图定位到选中项位置
          let map = this.map
          let BMap = this.baiduMap
          map.clearOverlays()
          this.center.lng = data.data.longitude ? data.data.longitude : '116.404'
          this.center.lat = data.data.latitude ? data.data.latitude : '39.915'
          let point = new BMap.Point(this.center.lng, this.center.lat);
          var marker = new BMap.Marker(point); // 创建标注
          map.addOverlay(marker); // 将标注添加到地图中
          map.panTo(point)
          let gc = new BMap.Geocoder();
          gc.getLocation(point, res => {
            console.log(res);
            this.selectLocation = res
          })
        } else {
          this.$message.error(data.msg);
        }
      })

    },
    delClick(row) { //删除
      this.$confirm('此操作将永久删除该单位以及子单位信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.delete('/organization/delete/' + row.id).then(data => {
          if (data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            let num = ''
            if (this.pagination.total > 1) {
               num = (this.pagination.total - 1) % this.pagination.pageSize
               if (num == 0) {
               this.pagination.currentPage = this.pagination.currentPage - 1
               }
            }
            this.showList();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!' + data.msg
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleConfirm(data) {
      //确认
      this.drawerShow = false;
      this.selectAddress = {}
      this.showList()
    },
    handleCancel(data) {
      //取消
      this.drawerShow = false;
    },
    //图片放大
    imgMask(data) {
      this.imgUrl = data
      this.showImg = true
    },
    saveLocation(){
      this.mapShow = false
      this.selectAddress = this.selectLocation
    },
    mapVisible(){
      this.mapShow = true
      if(!this.locationSelected){
        this.mapLoading = true
      }
    },
    mapReady({ BMap, map }) {
      this.baiduMap = BMap
      this.map = map
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition( res => {
        this.mapLoading = false
        console.log("转化前:" + res.longitude, res.latitude)
        var x_PI = 3.14159265358979324 * 3000.0 / 180.0
        var lat = +res.latitude
        var lng = +res.longitude
        var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI)
        var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI)
        var bd_lng = z * Math.cos(theta) + 0.0065
        var bd_lat = z * Math.sin(theta) + 0.006
        console.log("转化后:" + bd_lng, bd_lat)
        this.location.lng = bd_lng
        this.location.lat = bd_lat
        this.locationSelected = true
        if(!this.flag){
          this.center.lng = this.location.lng
          this.center.lat = this.location.lat
          let point = new BMap.Point(this.center.lng, this.center.lat);
          var marker = new BMap.Marker(point); // 创建标注
          map.addOverlay(marker); // 将标注添加到地图中
          map.panTo(point)
          let gc = new BMap.Geocoder();
          gc.getLocation(point, res => {
            console.log(res);
            this.selectLocation = res
          })
        }
        // console.log(point);
      }, {
        enableHighAccuracy: true
      })
      let Geo = new BMap.Geocoder();
      this.geocoder = Geo
    },
    mapClick(e) {
      let map = this.map
      let BMap = this.baiduMap
      map.clearOverlays();
      var point = new BMap.Point(e.point.lng, e.point.lat);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      this.geocoder.getLocation(point, res => {
        console.log(res);
        this.selectLocation = res
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.unitInformation {
  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .unitInfo {
      overflow: hidden;
      height: 100%;
    }

    // .radio{
    //    margin: 20px 0;
    // }
    .query {
      margin-bottom: 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

  }

  .imgMasking {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;

    .closeBtn {
      position: absolute;
      top: 50px;
      right: 100px;
      font-size: 50px;
      color: #fff;
    }

    .imgMask {
      height: 600px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;

      img {
        height: 100%;
      }
    }
  }
}

</style><style lang="scss">
.unitMap{
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 3000;
  transition:all 0.1s;
  .closeBtn {
    position: absolute;
    top: 30px;
    right: 80px;
    font-size: 50px;
    color: #fff;
    cursor: pointer;
  }
  .mapBox {
    position: absolute;
    width: 80%;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    overflow: hidden;
    .map {
      width: 100%;
      height: 100%;
    }

    .mapSearch {
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 1000;
      font-size: 0;

      .el-input {
        width: 300px;
        height: 40px;
        vertical-align: middle;
        margin-right: 10px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);

        .el-input__inner {
          width: 300px;
          height: 40px;
        }
      }

      .el-button {
        vertical-align: middle;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
      }
    }

    .mapConfirm{
      position: absolute;
      bottom: 0px;
      left: 0px;
      right: 0px;
      background: rgba(0,0,0,0.8);
      padding: 10px 20px;
      cursor: pointer;
      span{
        float: left;
        color: #fff;
        font-size: 20px;
        width: 500px;
        line-height:36px;        
      }
      i{
        float: right;
        background: #f77a27;
        font-style: normal;
        height:36px;
        line-height:36px;
        border-radius: 18px;
        padding: 0 20px;
        color: #fff;
        font-size: 20px;
      }
    }
  }
}
.unitInformation {
  .el-input {
    width: 380px;
    margin-right: 10px;

    .el-input__inner {
      line-height: 36px;
      height: 36px;
    }
  }

  .el-select {
    width: 170px;
    margin-right: 10px;

    .el-input {
      width: 170px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }
  }

  .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
    border-color: #42bced;
    background: #42bced;
  }

  .el-radio.is-checked .el-radio__label {
    color: #147dd9 !important;
  }

  .el-range-editor.el-input__inner {
    height: 36px;
    line-height: 36px;
    padding: 5px 10px;
    margin-right: 10px;
  }
}
</style>
